module.exports = __webpack_public_path__ + "img/angularjs-logo.4b5c0090.svg";